export const AAD_APP_CLIENT_ID = process.env.REACT_APP_AAD_APP_CLIENT_ID;
export const TENANT_NAME = process.env.REACT_APP_TENANT_NAME;
export const USER_FLOW_NAME = process.env.REACT_APP_USER_FLOW_NAME;
export const AUTHORITY = process.env.REACT_APP_AUTHORITY;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const APi_SIGNALR_URL = process.env.REACT_APP_SIGNALR_URL;
export const API_USER_SCOPES = process.env.REACT_APP_API_USER_SCOPES;
export const STORAGE = process.env.REACT_APP_STORAGE;
export const COUTRIES_JSON_PATH = process.env.REACT_APP_COUTRIES_JSON_PATH;
export const GEOTARGETS_JSON_PATH = process.env.REACT_APP_GEOTARGETS_JSON_PATH;
export const LANGUAGES_JSON_PATH = process.env.REACT_APP_LANGUAGES_JSON_PATH;
export const PHONE_INPUT_FLAGS_URL =
  process.env.REACT_APP_PHONE_INPUT_FLAGS_URL;
export const CALENDLY_LINK = process.env.REACT_APP_CALENDLY_LINK;
export const GTM_ID = process.env.REACT_APP_GTM_ID;

export const allEnvironmentVariablesProvided = Boolean(
  AAD_APP_CLIENT_ID &&
    TENANT_NAME &&
    USER_FLOW_NAME &&
    AUTHORITY &&
    API_BASE_URL &&
    API_USER_SCOPES &&
    STORAGE &&
    COUTRIES_JSON_PATH &&
    GEOTARGETS_JSON_PATH &&
    LANGUAGES_JSON_PATH &&
    PHONE_INPUT_FLAGS_URL &&
    CALENDLY_LINK &&
    GTM_ID
);

if (!allEnvironmentVariablesProvided) {
  throw new Error('Not all enviroment varriables provided ');
}

export const envConfigs: NodeJS.ProcessEnv = Object.freeze({
  REACT_APP_AAD_APP_CLIENT_ID: AAD_APP_CLIENT_ID,
  REACT_APP_TENANT_NAME: TENANT_NAME,
  REACT_APP_USER_FLOW_NAME: USER_FLOW_NAME,
  REACT_APP_AUTHORITY: AUTHORITY,
  REACT_APP_API_BASE_URL: API_BASE_URL,
  REACT_APP_SIGNALR_URL: APi_SIGNALR_URL,
  REACT_APP_API_USER_SCOPES: API_USER_SCOPES,
  REACT_APP_STORAGE: STORAGE,
  REACT_APP_COUTRIES_JSON_PATH: COUTRIES_JSON_PATH,
  REACT_APP_GEOTARGETS_JSON_PATH: GEOTARGETS_JSON_PATH,
  REACT_APP_LANGUAGES_JSON_PATH: LANGUAGES_JSON_PATH,
  REACT_APP_PHONE_INPUT_FLAGS_URL: PHONE_INPUT_FLAGS_URL,
  REACT_APP_CALENDLY_LINK: CALENDLY_LINK,
  REACT_APP_GTM_ID: GTM_ID,
});
